import React from 'react';
import { T } from '../../../../common/locale/translate';

export default class FlightType extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      active: false,
      pristine: true,
      flightTypes: ['C', 'C1', 'C2']
    };
  }

  componentWillReceiveProps = nextProps => {
    if (typeof nextProps.offer_type != 'undefined') {
      this.setState({ value: nextProps.offer_type });
    }
  };

  render = () => {
    return (
      <div
        className={
          'flight-type select-wrapper ' + (this.props.visible ? 'active' : '')
        }
        ref={() => {
          this.returnSearchedValue = this.returnSearchedValue.bind(this);
        }}
      >
        <ul className="flight-type-wrapper">
          <li className="item">
            <input
              type="radio"
              id="flight-type-to"
              className="filled-in"
              name="flight-type"
              onChange={this.handleChange}
              value="C1"
              checked={this.state.value == 'C1'}
            />
            <label htmlFor="flight-type-to"> {T('one_way_flight')} </label>
          </li>
          <li className="item">
            <input
              type="radio"
              id="flight-type-from"
              className="filled-in"
              name="flight-type"
              onChange={this.handleChange}
              value="C2"
              checked={this.state.value == 'C2'}
            />
            <label htmlFor="flight-type-from"> {T('two_ways_flight')} </label>
          </li>
        </ul>
      </div>
    );
  };

  handleChange = event => {
    this.setState({ value: event.target.value, pristine: false });
    if (typeof this.props.changeActivityStates == 'function') {
      this.props.changeActivityStates(event.target.value);
    }
  };

  handleBlur = () => this.setState({ active: false });

  handleFocus = () => this.setState({ active: true });

  returnSearchedValue = () => {
    return this.state.value.length &&
      this.state.flightTypes.indexOf(this.props.offer_type) > -1
      ? this.state.value
      : false;
  };
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/flight-type.js